import type { ComposantEcran } from '../../app/ecrans.js';
import { EcranD09, EcranM05 } from './conteneurs.js';

/** Fonctionnalité Documents (L58) : D09 GED et M05 photo de pièce. */

/** Écrans fournis par le lot L58 au registre de la coquille : D09 (documents du dossier) et M05 (photo d'une pièce). */
export const ecrans: Record<string, ComposantEcran> = { D09: EcranD09, M05: EcranM05 };

export { EcranD09, EcranM05, type DependancesD09, type DependancesM05 } from './conteneurs.js';
export { EcranDocuments, type PropsEcranDocuments } from './EcranDocuments.js';
export { EcranPhotoPiece, type PropsEcranPhotoPiece } from './EcranPhotoPiece.js';
export { creerControleurDocuments, type ControleurDocuments, type EtatDocuments } from './controleur-documents.js';
export {
  creerControleurPhoto,
  PREFIXE_PIECE_EN_ATTENTE,
  MESSAGES_PHOTO,
  type ControleurPhoto,
  type EtatPhoto,
  type OptionsControleurPhoto,
} from './controleur-photo.js';
export { clientAvecCle, envoyerPiece, type BilanEnvoiPiece, type OptionsEnvoiPiece } from './envoi-piece.js';
export { encodeurCanvas, lirePhoto, stockageMemoire, stockageNavigateur, transportTus } from './adaptateurs.js';
export { avisNettete, examinerPiece, messageMeilleurePhoto, type DecisionExamen } from './revue.js';
export { filtrerDocuments, optionsFiltres, type FiltreDocuments } from './filtres.js';
export { CATEGORIES_ACTES_NOTARIES, ficheTitre, separerDepots, typeDePiece, videosDuDossier } from './depots.js';
export { cadreDocument, compresserPhoto, PARAMETRES_PHOTO, resumeCompression, type Encodeur } from './photo.js';
export * as visionneuse from './visionneuse.js';
